import { useState, useEffect } from 'react';

export const useMultiSelection = (deps: any[]) => {
  const [allowMultiSelect, setAllowMultiSelect] = useState<boolean>(false);

  const handlePressShift = (e: KeyboardEvent) => {
    if (e.key === 'Shift') {
      if (e.type === 'keydown') {
        setAllowMultiSelect(true);
      }
      if (e.type === 'keyup') {
        setAllowMultiSelect(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handlePressShift);
    window.addEventListener('keyup', handlePressShift);
    return () => {
      window.removeEventListener('keydown', handlePressShift);
      window.removeEventListener('keyup', handlePressShift);
    };
  }, deps);

  return { allowMultiSelect };
};
